import { supportedLanguages } from '../i18n';

const userUpdateShape = new Map();

userUpdateShape.set('firstName', {
  label: 'common.firstname',
  required: true,
});

userUpdateShape.set('lastName', {
  label: 'common.lastname',
  required: true,
});

userUpdateShape.set('nickname', {
  label: 'common.nickname',
  required: true,
});

userUpdateShape.set('email', {
  label: 'common.email',
  disabled: true,
  required: true,
});

userUpdateShape.set('mobileNumber', {
  label: 'usersConfig.phone',
  required: true,
});

userUpdateShape.set('language', {
  label: 'usersConfig.language',
  required: false,
  kind: 'select',
  options: supportedLanguages.map(lang => ({
    key: lang,
    text: lang,
    value: lang,
  })),
});

export default userUpdateShape;



// WEBPACK FOOTER //
// ./src/shapes/userUpdateShape.js